'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);


var _MobileContacts = require('../../MobileContacts/MobileContacts');var _MobileContacts2 = _interopRequireDefault(_MobileContacts);
var _PropertyDetailedForm = require('../../../containers/PropertyDetailedContactsUsForm/PropertyDetailedForm');var _PropertyDetailedForm2 = _interopRequireDefault(_PropertyDetailedForm);


var _analyticsManager = require('../../../utils/analytics/analyticsManager');



var _analyticsConstants = require('../../../utils/analytics/analyticsConstants');




var _constants = require('../../../constants');
var _RealtorContact = require('./RealtorContact/RealtorContact');var _RealtorContact2 = _interopRequireDefault(_RealtorContact);
var _RegularUserContact = require('./RegularUserContact/RegularUserContact');var _RegularUserContact2 = _interopRequireDefault(_RegularUserContact);
var _CompanyContact = require('./CompanyContact/CompanyContact');var _CompanyContact2 = _interopRequireDefault(_CompanyContact);

var _BasicInformation = require('./BasicInformation.scss');var _BasicInformation2 = _interopRequireDefault(_BasicInformation);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
// Styles
var Contacts = function (_Component) {_inherits(Contacts, _Component);function Contacts(props) {_classCallCheck(this, Contacts);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.















    handleCopy = function () {
      var textNode = document.createElement('span');
      textNode.textContent = _this.phoneNumber;
      document.body.appendChild(textNode);
      var range = document.createRange();
      range.selectNode(textNode);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);

      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      document.body.removeChild(textNode);
      _this.setState({ isCopiedPhone: true }, function () {return setTimeout(function () {return _this.setState({ isCopiedPhone: false });}, 5000);});
    };_this.

    handleClick = function (type) {var
      propertyId = _this.props.data.propertyId;

      if (!_this.state.phoneIsRevealed[type]) {
        _this.handleShowPhone(type);
      } else {
        (0, _analyticsManager.trackGTM)({ name: _analyticsConstants.eventCategory.contactViews });
        // trackGTM({
        //   name: this.props.searchOption === 'forSale'
        //     ? eventCategory.contactViewsSale
        //     : eventCategory.contactViewsRent
        //   }
        // );
        (0, _analyticsManager.trackEvent)(
        _analyticsConstants.eventCategory.property,
        _this.props.searchOption === 'forSale' ?
        _analyticsConstants.eventLabel.contactViewsSale :
        _analyticsConstants.eventLabel.contactViewsRent);

        _this.props.incrementClicks({
          propertyId: propertyId,
          action: _constants.analyticsEventAction.SHOW_NUMBER });

        (0, _analyticsManager.trackEvent)(
        _analyticsConstants.eventCategory.propertyDetails,
        _analyticsConstants.eventAction.show,
        _analyticsConstants.eventLabel.phoneNumber);

      }
    };_this.

    handleShowPhone = function () {var
      propertyId = _this.props.data.propertyId;

      (0, _analyticsManager.trackGTM)({ name: _analyticsConstants.eventCategory.contactViews });
      // trackGTM({
      //   name: this.props.searchOption === 'forSale'
      //     ? eventCategory.contactViewsSale
      //     : eventCategory.contactViewsRent
      //   }
      // );
      (0, _analyticsManager.trackEvent)(
      _analyticsConstants.eventCategory.property,
      _this.props.searchOption === 'forSale' ?
      _analyticsConstants.eventLabel.contactViewsSale :
      _analyticsConstants.eventLabel.contactViewsRent);

      _this.props.incrementClicks({
        propertyId: propertyId,
        action: _constants.analyticsEventAction.SHOW_NUMBER });

      (0, _analyticsManager.trackEvent)(
      _analyticsConstants.eventCategory.propertyDetails,
      _analyticsConstants.eventAction.show,
      _analyticsConstants.eventLabel.phoneNumber);

    };_this.

    handleCloseModal = function () {
      _this.setState({ showContactForm: false });
      _this.props.closeMobileContactsModal();
    };_this.

    renderTooltip = function () {
      var title = _this.props.
      translate('propertyDetails', 'contacts', 'onMapTitle').
      split('%s');

      title.splice(1, 0, _react2.default.createElement('span', { key: 'contacts', className: _BasicInformation2.default.logoTitle }, 'OnMap'));

      return title;
    };_this.

    renderMobileContact = function () {var _this$props =











      _this.props,contacts = _this$props.contacts,translate = _this$props.translate,isForeign = _this$props.isForeign,data = _this$props.data,isContactBlockVisible = _this$props.isContactBlockVisible,isCompanyActive = _this$props.isCompanyActive,realEstateData = _this$props.realEstateData,isModalOpen = _this$props.isModalOpen,locale = _this$props.locale,openMobileContactsModal = _this$props.openMobileContactsModal;

      var hiddenClass = !isContactBlockVisible ? '' : _BasicInformation2.default.hiddenButtons;

      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_BasicInformation2.default.buttons, hiddenClass) },
          _react2.default.createElement('button', {
              type: 'button',
              className: (0, _classnames2.default)(_BasicInformation2.default.hideText, 'btn btn-primary'),
              onClick: openMobileContactsModal },

            translate('propertyDetails', 'contacts', 'agentTitle')),

          isModalOpen &&
          _react2.default.createElement(_MobileContacts2.default, {
              contacts: contacts,
              locale: locale,
              isCompanyActive: isCompanyActive,
              realEstateData: realEstateData,
              isOpen: isModalOpen,
              onRequestClose: _this.handleCloseModal,
              onMapTitle: _this.renderTooltip(),
              translate: translate,
              onRevealPhone: _this.handleShowPhone,
              onSendMessage: function onSendMessage() {return _this.setState({ showContactForm: true });} },

            _this.state.showContactForm &&
            _react2.default.createElement(_PropertyDetailedForm2.default, {
              isModal: false,
              entityId: data.propertyId,
              isForeign: isForeign,
              entityType: 'property' }))));






    };_this.phoneNumber = props.contacts && props.contacts.primary && props.contacts.primary.phone;_this.state = { isCopiedPhone: false, phoneIsRevealed: { primary: false, secondary: false }, showTooltip: { primary: false, secondary: false }, showContactForm: false };return _this;}Contacts.prototype.

  render = function render() {var _props =








    this.props,translate = _props.translate,isMobile = _props.isMobile,contacts = _props.contacts,isCompanyActive = _props.isCompanyActive,realEstateData = _props.realEstateData,locale = _props.locale,scrollToForm = _props.scrollToForm;

    if (isMobile) {
      return this.renderMobileContact('primary');
    }var

    isRealtorProperty = realEstateData.isAgent;

    if (!isRealtorProperty) {
      return (
        _react2.default.createElement(_RegularUserContact2.default, {
          locale: locale,
          translate: translate,
          contact: contacts.primary,
          onSendMessage: scrollToForm,
          onRevealPhone: this.handleShowPhone }));


    }

    return (
      _react2.default.createElement('div', { className: _BasicInformation2.default.contactsList },
        _react2.default.createElement(_CompanyContact2.default, {
          locale: locale,
          translate: translate,
          realEstateData: realEstateData,
          onScrollToForm: scrollToForm,
          isCompanyActive: isCompanyActive }),

        !(0, _isEmpty2.default)(contacts.primary) &&
        _react2.default.createElement(_RealtorContact2.default, {
          onRevealPhone: this.handleShowPhone,
          locale: locale,
          translate: translate,
          contact: contacts.primary }),


        !(0, _isEmpty2.default)(contacts.secondary) &&
        _react2.default.createElement(_RealtorContact2.default, {
          onRevealPhone: this.handleShowPhone,
          locale: locale,
          translate: translate,
          contact: contacts.secondary })));




  };return Contacts;}(_react.Component);exports.default = Contacts;


Contacts.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  realEstateData: _propTypes2.default.object,
  data: _propTypes2.default.object,
  contacts: _propTypes2.default.object,
  searchOption: _propTypes2.default.string,
  scrollToForm: _propTypes2.default.func,
  incrementClicks: _propTypes2.default.func,
  isForeign: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  isCompanyActive: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  isModalOpen: _propTypes2.default.bool,
  openMobileContactsModal: _propTypes2.default.func,
  closeMobileContactsModal: _propTypes2.default.func,
  isContactBlockVisible: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/BasicInformation/Contacts.js
// module id = 2816
// module chunks = 0